import { TFunction } from 'i18next';
import { object, string } from 'yup';
import { CountryCodes, UserLanguages } from '@cnx-saas/common';

function getAccountFormSchema(t: TFunction) {
  return object({
    firstName: string().required(t('account.validation.firstName.required')),
    lastName: string().required(t('account.validation.lasetName.required')),
    language: string()
      .oneOf(
        Object.values(UserLanguages),
        t('account.validation.language.oneOf'),
      )
      .required(t('account.validation.language.required')),
    email: string().email().required(t('account.validation.email.required')),
    address: object({
      street: string().required(t('account.validation.street.required')),
      city: string().required(t('account.validation.city.required')),
      zipCode: string().required(t('account.validation.zipCode.required')),
      country: string()
        .oneOf(
          Object.values(CountryCodes),
          t('account.validation.country.oneOf'),
        )
        .required(t('account.validation.country.required')),
    }),
    taxId: string().required(t('account.validation.taxId.required')),
  });
}

export { getAccountFormSchema };
